import {BCMSRecord ,BCMSRecordProperty} from "bcms-react"; 
import Classes, { Account, Payee, LinkedAccount, CheckingAccount } from "model";

/**
* @class WireHistory
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.wireHistory[0];
* const wireHistory = new WireHistory(record);
* @property {STRING} _id - The id of the history
* @property {STRING} _referenceNumber - The referenceNumber of the history
* @property {} _payee - The payee of the history
* @property {} _fundingAccount - The funding account of the history
* @property {BCMSCurrency} _amount - The amount of the history
* @property {STRING} _statusDescription - The statusDescription of the history
* @property {BCMSDate} _wireDate - The wire date of the history
* @property {BCMSDate} _futureWireDate - The wire date of the history
* @property {STRING} _memo - The wire date of the history
* @property {BCMSDate} _recurringEndByDate - The recurringEndByDate of the history
* @property {BCMSDate} _recurringWireDate - The recurringWireDate of the history
* @property {BCMSDate} _recurringNumberOfTransfers - The recurringNumberOfTransfers of the history
* @property {STRING} _schedulingOption - The schedulingOption of the history
* @property {STRING} _frequency - The frequency of the history
* @property {STRING} _frequencyType - The frequencyType of the history
*/
export default class WireHistory extends BCMSRecord {
    _id
    _referenceNumber
    _payee
    _fundingAccount
    _amount
    _statusDescription
    _wireDate
    _futureWireDate
    _memo
    _recurringEndByDate
    _recurringWireDate
    _recurringNumberOfTransfers
    _schedulingOption
    _frequency
    _frequencyType

    constructor(record) {     
      super(record) 
    }
  }
  WireHistory.define({
    "recordType":"wireHistory",
    "recordIDProp":"id",
    "className" : "WireHistory",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id 
       * @property set {NUMBER} - sets the id 
       * @memberof WireHistory
       */
      BCMSRecordProperty.mapToString("id","_id"),
      /** 
       * @name referenceNumber
       * @instance
       * @property get {STRING} - gets the reference number
       * @property set {STRING} - sets the reference number
       * @memberof WireHistory
       */
      BCMSRecordProperty.mapToString("referenceNumber","_referenceNumber"),
      /** 
       * @name payee
       * @instance
       * @property get {STRING} - gets the payee
       * @property set {STRING} - sets the payee
       * @memberof WireHistory
       */
      BCMSRecordProperty.mapToClass("payee","_payee", () => Payee),
       /** 
       * @name fundingAccount
       * @instance
       * @property get {STRING} - gets the funding account
       * @property set {STRING} - sets the funding account
       * @memberof WireHistory
       */
      BCMSRecordProperty.mapToClass("fundingAccount","_fundingAccount", () => CheckingAccount),
       /** 
       * @name amount
       * @instance
       * @property get {STRING} - gets the amount
       * @property set {STRING} - sets the amount
       * @memberof WireHistory
       */
      BCMSRecordProperty.mapToCurrency("amount","_amount"),
       /** 
       * @name statusDescription
       * @instance
       * @property get {STRING} - gets the statusDescription
       * @property set {STRING} - sets the statusDescription
       * @memberof WireHistory
       */
      BCMSRecordProperty.mapToString("statusDescription","_statusDescription"),
       /** 
       * @name wireDate
       * @instance
       * @property get {STRING} - gets the wireDate
       * @property set {STRING} - sets the wireDate
       * @memberof WireHistory
       */
      BCMSRecordProperty.mapToDate("wireDate","_wireDate"),
      /** 
       * @name futureWireDate
       * @instance
       * @property get {STRING} - gets the futureWireDate
       * @property set {STRING} - sets the futureWireDate
       * @memberof WireHistory
       */
      BCMSRecordProperty.mapToDate("futureWireDate","_futureWireDate"),
      /** 
       * @name memo
       * @instance
       * @property get {STRING} - gets the memo
       * @property set {STRING} - sets the memo
       * @memberof WireHistory
       */
      BCMSRecordProperty.mapToString("memo","_memo"),
      /** 
       * @name recurringEndByDate
       * @instance
       * @property get {STRING} - gets the recurringEndByDate
       * @property set {STRING} - sets the recurringEndByDate
       * @memberof WireHistory
       */
      BCMSRecordProperty.mapToDate("recurringEndByDate","_recurringEndByDate"),
      /** 
       * @name recurringWireDate
       * @instance
       * @property get {STRING} - gets the recurringWireDate
       * @property set {STRING} - sets the recurringWireDate
       * @memberof WireHistory
       */
      BCMSRecordProperty.mapToDate("recurringWireDate","_recurringWireDate"),
      /** 
       * @name recurringNumberOfTransfers
       * @instance
       * @property get {STRING} - gets the recurringNumberOfTransfers
       * @property set {STRING} - sets the recurringNumberOfTransfers
       * @memberof WireHistory
       */
      BCMSRecordProperty.mapToString("recurringNumberOfTransfers","_recurringNumberOfTransfers"),
      /** 
       * @name schedulingOption
       * @instance
       * @property get {STRING} - gets the schedulingOption
       * @property set {STRING} - sets the schedulingOption
       * @memberof WireHistory
       */
      BCMSRecordProperty.mapToString("schedulingOption","_schedulingOption"),
      /** 
       * @name frequency
       * @instance
       * @property get {STRING} - gets the frequency
       * @property set {STRING} - sets the frequency
       * @memberof WireHistory
       */
      BCMSRecordProperty.mapToString("frequency","_frequency"),
      /** 
       * @name frequencyType
       * @instance
       * @property get {STRING} - gets the frequencyType
       * @property set {STRING} - sets the frequencyType
       * @memberof WireHistory
       */
      BCMSRecordProperty.mapToString("frequencyType","_frequencyType"),
    ]  
})




